export default __webpack_public_path__ + "static/media/Flower arrangement1_primary.a0727982.jpg";